module.exports = __webpack_public_path__ + "img/left-foot-angle.138b5208.png";